var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_13319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.707 0.293153C23.5195 0.105682 23.2652 0.000366211 23 0.000366211C22.7349 0.000366211 22.4806 0.105682 22.293 0.293153L12 10.5862L1.70703 0.293153C1.5195 0.105682 1.26519 0.000366211 1.00003 0.000366211C0.734866 0.000366211 0.480558 0.105682 0.293031 0.293153V0.293153C0.10556 0.48068 0.000244141 0.734988 0.000244141 1.00015C0.000244141 1.26532 0.10556 1.51963 0.293031 1.70715L10.586 12.0002L0.293031 22.2932C0.10556 22.4807 0.000244141 22.735 0.000244141 23.0002C0.000244141 23.2653 0.10556 23.5196 0.293031 23.7072V23.7072C0.480558 23.8946 0.734866 23.9999 1.00003 23.9999C1.26519 23.9999 1.5195 23.8946 1.70703 23.7072L12 13.4142L22.293 23.7072C22.4806 23.8946 22.7349 23.9999 23 23.9999C23.2652 23.9999 23.5195 23.8946 23.707 23.7072C23.8945 23.5196 23.9998 23.2653 23.9998 23.0002C23.9998 22.735 23.8945 22.4807 23.707 22.2932L13.414 12.0002L23.707 1.70715C23.8945 1.51963 23.9998 1.26532 23.9998 1.00015C23.9998 0.734988 23.8945 0.48068 23.707 0.293153V0.293153Z",
    fill: "#405C43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_13319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiCrossIcon);
export default __webpack_public_path__ + "static/media/tildi-cross-icon.e10cf3bca575c2291ac7660e04a686f9.svg";
export { ForwardRef as ReactComponent };